const REMOVE_DELIVERYMAN_MODAL = {
  default:
    'Ao excluir $name, ele será notificado que não receberá mais pedidos da sua loja.',
  submitButtonLabel: 'Excluir entregador',
  cancelButtonLabel: 'Cancelar',
  removeDeliveryman: {
    success: 'Entregador removido com sucesso!',
    error: 'Erro ao remover entregador, tente novamente.',
  },
}

export default REMOVE_DELIVERYMAN_MODAL
